module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section",
    attrs: {
      "id": "skills"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "block has-text-centered"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Skills")]), _vm._v(" "), _c('separator'), _vm._v(" "), _c('h5', {
    staticClass: "subtitle is-5"
  }, [_vm._v("Technologies I work in most frequently.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "skills columns is-multiline is-mobile"
  }, _vm._l((_vm.skills), function(skill, index) {
    return _c('div', {
      key: index,
      staticClass: "column is-half-mobile is-one-third-tablet is-one-quarter-desktop"
    }, [_c('div', {
      staticClass: "skill"
    }, [_c('a', {
      staticClass: "image",
      attrs: {
        "target": "_blank",
        "rel": "noopener",
        "href": skill.url,
        "title": skill.name
      }
    }, [_c('clazyload', {
      attrs: {
        "src": skill.image
      }
    }, [_c('img', {
      attrs: {
        "src": skill.image,
        "alt": skill.name
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "preloader",
      attrs: {
        "slot": "placeholder"
      },
      slot: "placeholder"
    })])], 1)])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10f33820"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Skills/index.vue
// module id = 539
// module chunks = 1